import * as React from 'react'
import Icon from '../icon/icon'
import Modal from './modal'

interface ConfirmDeleteFileProps {
  additional?: string
  busy?: boolean
  info: string
  onClickPrimary: () => void
  onClickSecondary?: () => void
  onClose: () => void
  primaryButtonText?: string
  secondaryButtonText?: string
  title: string
}

const ConfirmDeleteFileDialog: React.SFC<ConfirmDeleteFileProps> = ({
  additional,
  busy,
  children,
  info,
  onClickPrimary,
  onClickSecondary,
  onClose,
  primaryButtonText,
  secondaryButtonText,
  title,
}) => (
  <Modal>
    <div className='modal warning'>
      <div className='modal-body'>
        <button
          id='modal-button-close'
          type='button'
          className='close'
          aria-label='Close'
          onClick={onClose}
        >
          <span aria-hidden='true'>&times;</span>
        </button>
        <div className='modal-icon'>
          <Icon icon={busy ? 'loading' : 'delete'} />
        </div>
        <div className='modal-title confirm-delete'>{title}</div>
        <div className='modal-info'>{info}</div>
        <div className='modal-additional'>{additional}</div>
        <div className='modal-children'>
          {children}
        </div>
        <div className='modal-buttons'>
          {onClickSecondary && (
            <button
              id='modal-secondary-button'
              className='btn'
              onClick={onClickSecondary}
            >
              {secondaryButtonText}
            </button>
          )}
          <button
            id='modal-primary-button'
            className='btn btn-primary'
            autoFocus={true}
            onClick={onClickPrimary}
          >
            {primaryButtonText}
          </button>
        </div>
      </div>
    </div>
  </Modal>
)

ConfirmDeleteFileDialog.defaultProps = {
  primaryButtonText: 'OK',
  secondaryButtonText: 'Cancel',
}

export default ConfirmDeleteFileDialog
